import { HttpClient } from '@angular/common/http';
import { ILoginRequest } from '../pages/login/login.interface';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';

export type ListDoctorsResponse = {
  id: number;
  externalId: number;
  name: string;
  cpf: string;
  birthDate: Date | null;
  mobilePhone: string;
  addressStreet: string;
  addressNumber: string;
  addressPostalCode: string;
  addressProvince: string;
  createdAt: Date;
  isActive: boolean;
  email?: string | null;
};

@Injectable({
  providedIn: 'root',
})
export class DoctorV2Service {
  private url = `${environment.api_v2}/v2/doctor`;

  constructor(private readonly http: HttpClient) {}

  public findAll(): Observable<ListDoctorsResponse[]> {
    return this.http.get<ListDoctorsResponse[]>(this.url);
  }

  public findById(id: number): Observable<ListDoctorsResponse> {
    return this.http.get<ListDoctorsResponse>(`${this.url}/${id}`).pipe(take(1));
  }
}
